const testingId = new Set<string>();

const setTestingId = (experiments: string[]): void => {
  experiments.forEach((experiment) => testingId.add(experiment));
};

const resetTestingId = (): void => {
  testingId.clear();
};

const spreadableTestingId: () => { testingId?: string[] } = () =>
  testingId.size ? { testingId: Array.from(testingId) } : {};

export { setTestingId, resetTestingId, spreadableTestingId };
